const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const getSession = () => {
  try {
    let s = sessionStorage.getItem("tlp-session");
    if (!s) {
      s = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("tlp-session", s);
    }
    return s;
  } catch {
    return "anon";
  }
};

export const getUtm = () => {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  return utm;
};

export const getSrc = (fallback = "") => {
  const v = new URLSearchParams(window.location.search).get("src");
  return v || fallback;
};

export const track = (type, extra = {}) => {
  try {
    fetch(`${API}/assessment/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        session: getSession(),
        utm: getUtm(),
        referrer: document.referrer || "",
        landing: window.location.pathname,
        ...extra,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics must never break UX */
  }
};

export const apiFetch = async (path, options = {}) => {
  const res = await fetch(`${API}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Request failed");
  return data;
};

export { API };
